import { render, staticRenderFns } from "./PropertyModal.vue?vue&type=template&id=65bb3782"
import script from "./PropertyModal.vue?vue&type=script&lang=js"
export * from "./PropertyModal.vue?vue&type=script&lang=js"
import style0 from "./PropertyModal.vue?vue&type=style&index=0&id=65bb3782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports